import type {
  Brand,
  BrandCreditAccount,
  ExpenseBudgetCategory,
  GetCreditAccountQuery,
  OurWorkBudgetCategory,
  Team,
} from "@src/__generated__/graphql";
import { map } from "lodash";
import type { DeepPick } from "ts-essentials";

type TBrandCreditAccount = NonNullable<
  GetCreditAccountQuery["brandCreditAccount"]
>;
type TBrand = NonNullable<TBrandCreditAccount["brand"]>;
type TTeam = NonNullable<TBrandCreditAccount["team"]>;
type TOurWorkBudgetCategory = NonNullable<
  TBrandCreditAccount["ourWorkBudgetCategories"]
>[0];
type TExpenseBudgetCategory = NonNullable<
  TBrandCreditAccount["expenseBudgetCategories"]
>[0];

export class BrandCreditAccountModel {
  id: BrandCreditAccount["id"];
  title: BrandCreditAccount["title"];
  brand: BrandModel;
  team: TeamModel;
  ourWorkBudgetCategories: OurWorkBudgetCategoryModel[];
  expenseBudgetCategories: ExpenseBudgetCategoryModel[];
  credits: TBrandCreditAccount["credits"];
  debits: TBrandCreditAccount["debits"];
  stats: TBrandCreditAccount["stats"];

  creditAccount: TBrandCreditAccount["creditAccount"];

  constructor(src: TBrandCreditAccount) {
    this.id = src.id;
    this.title = src.title;
    this.brand = new BrandModel(src.brand);
    this.team = new TeamModel(src.team);
    this.ourWorkBudgetCategories = map(
      src.ourWorkBudgetCategories,
      (c) => new OurWorkBudgetCategoryModel(c),
    );
    this.expenseBudgetCategories = map(
      src.expenseBudgetCategories,
      (c) => new ExpenseBudgetCategoryModel(c),
    );
    this.stats = src.stats;
    this.credits = src.credits;
    this.debits = src.debits;
    this.creditAccount = src.creditAccount;
  }
}

class BrandModel {
  name: Brand["name"];
  id: Brand["id"];
  image: DeepPick<
    Brand["image"],
    {
      urls: {
        thumbnail: never;
      };
    }
  >;
  constructor(src: TBrand) {
    this.name = src.name;
    this.id = src.id;
    this.image = src.image;
  }
}

class TeamModel {
  id: Team["id"];
  name: Team["name"];
  constructor(src: TTeam) {
    this.id = src.id;
    this.name = src.name;
  }
}

class OurWorkBudgetCategoryModel {
  id: OurWorkBudgetCategory["id"];
  name: OurWorkBudgetCategory["name"];
  constructor(src: TOurWorkBudgetCategory) {
    this.name = src.name;
    this.id = src.id;
  }
}

class ExpenseBudgetCategoryModel {
  id: ExpenseBudgetCategory["id"];
  name: ExpenseBudgetCategory["name"];
  constructor(src: TExpenseBudgetCategory) {
    this.name = src.name;
    this.id = src.id;
  }
}
